import { useEffect, useState } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { FULL_NAME } from "helpers/common";
import MessagingInterface from "components/shared/ChatComponent/MessagingInterface";
import NoChatSelected from "./Component/NoChatSelected";
import { initiateConversation } from "store/services/clientMessagingService";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useWebSocket } from "Providers/WebSocketContext";
import { useNavigate } from "react-router-dom";
import { dashboard } from "Routes/paths";

// icns

const Messaging = ({
  dispatch,
  userInfo,
  conversation
}) => {
  const navigate = useNavigate();
  const {isChatEnabled} = useWebSocket();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!isChatEnabled) {
      navigate(dashboard);
    }

    async function loadConversation() {
      try {
        setLoading(true);
        await dispatch(initiateConversation());
        setLoading(false);
      } catch(err) {
        console.error("Error initiating conversation", err);
        setLoading(false);
      }
    }

    loadConversation();
  }, [isChatEnabled]);

  const practFullName = (conv) => {
    return FULL_NAME(conv.pract_first_name, conv.pract_last_name)
  }

  return (
    <>
      <section className="d-flex">
        <Container fluid>
          <Row className="my-4">
            <Col lg={10} className="p-0 border mx-auto">
              <div style={{ minHeight: "500px", position: "relative" }}>
                {isLoading ? (
                  <div className="h-100 w-100 align-items-center justify-content-center">
                    <LoadingIndicator
                      size={10}
                    />
                  </div>
                ): conversation ? (
                  <>
                    <div className="p-3 d-flex justify-content-between align-items-center border-bottom bg-light">
                      <div>
                        <h6 className="fw-sbold theme-clr">{practFullName(conversation)}</h6>
                      </div>
                      <Badge bg={conversation.active_status ? "success" : "secondary"}>
                        {conversation.active_status ? "Online" : "Offline"}
                      </Badge>
                    </div>
                    <MessagingInterface
                      userId={userInfo?.id}
                      practId={conversation?.pract_id}
                      conversationId={conversation?.conversation_id}
                      practName={practFullName(conversation)}
                    />
                  </>
                ) : (
                  <NoChatSelected />
                )}
              </div>
            </Col>
          </Row>
        </Container>

      </section>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    userInfo: state.Profile.user,
    conversation: state.ClientMessaging.conversation,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Messaging);